import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import {
  Button,
  DropDownButton,
  DropDownButtonItem,
} from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete, MdPrint } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";
import {
  checkAcessRights,
  convertHtmlToWhatsAppFormat,
  copyHtmlToClipboard,
} from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
// import { BsBookmarkPlusFill } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
// import { generateFITBookingByQuotationID } from "../fitbooking/services/FITBooking.services";
// import { RiBookMarkedLine } from "react-icons/ri";
// import { TbMailShare } from "react-icons/tb";
import IconComponent from "../../components/common/IconComponent";
import AlertBox from "../../components/common/AlertBox";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  deleteFlightQuotation,
  getAllFlightQuotations,
  getFlightQuotationHistoryByParentID,
  getFlightQuotationMessageForCopy,
} from "./services/quotation.services";
import {
  clearFlightQuotationFilterDetails,
  clearFlightQuotationID,
  setFlightQuotationID,
} from "./quotationSlice";
import { getAllActiveVendors } from "../vendor/services/vendor.services";
import { getAllActiveFlightPlaces } from "../flightplace/services/flightplace.services";
import { getAllActiveUsers } from "../user/services/user.services";
import FlightQuotationFilter from "./FlightQuotationFilter";
import moment from "moment";
import { clipboardIcon } from "@progress/kendo-svg-icons";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";

const FlightQuotationGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const LeadID = location.state?.LeadID;
  // const ContactID = location.state?.ContactID;
  // const InquiryID = location.state?.InquiryID;
  // const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const FlightQuotationList = useAppSelector(
    (state) => state.quotation.FlightQuotationList,
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  const messageLoading = useAppSelector(
    (state) => state.quotation.messageLoading,
  );
  const FITLoading = useAppSelector((state) => state.FITBooking.loading);
  const FlightQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.FlightQuotationFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    // const matchFilter = (id: any, filterId: any) =>
    //   (!id && !filterId) || (id && filterId);

    // const hasMatchingFilterID =
    //   matchFilter(ContactID, FlightQuotationFilterDetails?.filterContactID) &&
    //   matchFilter(InquiryID, FlightQuotationFilterDetails?.filterInquiryID) &&
    //   matchFilter(LeadID, FlightQuotationFilterDetails?.filterLeadID);

    // if (hasMatchingFilterID) {
    dispatch(
      getAllFlightQuotations({
        ...FlightQuotationFilterDetails,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      }),
    );
    // }
  }, [FlightQuotationFilterDetails, currentPage, pageLimit]);

  useEffect(() => {
    dispatch(getAllActiveVendors());
    dispatch(getAllActiveFlightPlaces());
    dispatch(getAllActiveUsers());

    return () => {
      if (!isEditBtnRef.current) {
        dispatch(setCurrentPage(0));
        dispatch(setPageLimit(50));
        dispatch(clearFlightQuotationFilterDetails());
      }
    };
  }, []);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  // const handleAddTourBooking = async (data: any) => {
  //   if (data?.ID) {
  //     dispatch(openDialog("bookingConfirmationDialog"));
  //     dispatch(setFlightQuotationID(data?.ID));
  //   }
  // };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/flight/edit", {
        state: {
          FlightQuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteFlightQuotation"));
      dispatch(setFlightQuotationID(ID));
    };

    // const handleSendEmail = async (ID: number) => {
    //   if (ID) {
    //     dispatch(openDialog("emailConfirmationDialog"));
    //     dispatch(setFlightQuotationID(ID));
    //   }
    // };

    const handlePrint = async (FlightQuot_GUID: string) => {
      if (FlightQuot_GUID) {
        window.open(`/quotation/flight/view/${FlightQuot_GUID}`);
      }
    };

    const handleCopyMessage = async (ID: number, type = "email") => {
      try {
        if (ID) {
          const res = await dispatch(
            getFlightQuotationMessageForCopy({
              ID: ID,
              MessageType: type,
            }),
          );

          const htmlContent = res?.payload?.WhatsAppMessage || "";

          if (htmlContent) {
            let textToCopy = htmlContent;

            if (type === "whatsapp") {
              // Convert HTML to WhatsApp formatted text
              textToCopy = convertHtmlToWhatsAppFormat(htmlContent);
            } else if (type === "email") {
              // For email, copy as HTML with formatting
              await copyHtmlToClipboard(htmlContent);
              SuccessToast(
                `Message copied with formatting! You can now paste it in ${type}`,
              );
              return;
            }

            // Copy to clipboard
            await navigator.clipboard.writeText(textToCopy);

            SuccessToast(
              `Message copied to clipboard! You can now paste it in ${type}`,
            );
          } else {
            ErrorToast("No message found to copy.");
          }
        }
      } catch (error) {
        console.error("Failed to copy message:", error);
        alert("Failed to copy message. Please try again.");
      }
    };

    const handleCopyItemClick = (event: any, ID: number) => {
      const clickedItem = event?.item?.text;

      if (clickedItem === "Whatsapp") {
        handleCopyMessage(ID, "whatsapp");
      } else if (clickedItem === "Email") {
        handleCopyMessage(ID, "email");
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {/* {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(props.dataItem)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )} */}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        /> */}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            themeColor="dark"
            onClick={() => handlePrint(props.dataItem.FlightQuot_GUID)}
            icon={MdPrint}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <DropDownButton
            svgIcon={clipboardIcon}
            className="drop-down-btn"
            fillMode={"flat"}
            title="Copy Message"
            themeColor={"primary"}
            onItemClick={(event) =>
              handleCopyItemClick(event, props.dataItem.ID)
            }
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "center", vertical: "top" },
            }}
          >
            <DropDownButtonItem text="Whatsapp" />
            <DropDownButtonItem text="Email" />
          </DropDownButton>
        </Tooltip>
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 13 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props.tdProps} />
  );

  // const ListingButtonCell = (props: any) => {
  //   const handleBookings = (ID: number) => {
  //     navigate("/tourbooking", { state: { FlightQuotationID: ID } });
  //   };
  //   const handleFITBookings = (ID: number) => {
  //     navigate("/fitbooking", { state: { FlightQuotationID: ID } });
  //   };

  //   return (
  //     <td
  //       {...props.tdProps}
  //       className={`action-td ${props.className}`}
  //       style={{ ...props.tdProps.style }}
  //     >
  //       {false && (
  //         <IconButton
  //           type="button"
  //           fillMode="flat"
  //           size="small"
  //           title="Tour Bookings"
  //           themeColor="tertiary"
  //           onClick={() => handleBookings(props.dataItem.ID)}
  //           icon={BsBookmarkPlusFill}
  //           iconClassName="absolute-position"
  //           iconStyle={{ fontSize: "20px" }}
  //         />
  //       )}
  //       <IconButton
  //         type="button"
  //         fillMode="flat"
  //         size="small"
  //         title="FIT Bookings"
  //         themeColor="dark"
  //         onClick={() => handleFITBookings(props.dataItem.ID)}
  //         icon={RiBookMarkedLine}
  //         iconClassName="absolute-position"
  //         iconStyle={{ fontSize: "20px" }}
  //       />
  //     </td>
  //   );
  // };

  const handleChildView = async (props: any) => {
    const res = await dispatch(
      getFlightQuotationHistoryByParentID(props?.ParentID),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(openDialog("childFlightQuotationHistory"));
    }
  };

  return (
    <>
      <ChildFlightQuotationDialog />
      <DeleteFlightQuotationDialog />
      {/* <BookingConfirmationDialog /> */}
      {/* <EmailConfirmationDialog /> */}
      {(loading || FITLoading || messageLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <FlightQuotationFilter />
      </div>
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 265px)" }}
        className="responsive-table"
        filterable={false}
        data={FlightQuotationList}
        total={FlightQuotationList[0]?.ItemCount || FlightQuotationList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="FlightQuotationNo"
          title="Quotation No."
          width={130}
          cells={{
            data: (props: any) => (
              <td>
                {isEditAccess ? (
                  <div className="d-flex gap-2 align-items-center">
                    <div
                      className="hoverableName"
                      onClick={() =>
                        navigate("/quotation/flight/edit", {
                          state: {
                            FlightQuotationID: props.dataItem?.ID,
                            SectorID: props.dataItem?.SectorID,
                          },
                        })
                      }
                    >
                      {props.dataItem?.FlightQuotationNo}
                    </div>
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <Tooltip
                          anchorElement="target"
                          position="top"
                          parentTitle={true}
                        >
                          <IconComponent
                            icon={FaEye}
                            title="View History"
                            style={{
                              color: "green",
                              fontSize: 18,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="normalName">
                    {props.dataItem?.FlightQuotationNo}
                    {props.dataItem?.ParentID &&
                    props.dataItem?.ParentID > 0 ? (
                      <div onClick={() => handleChildView(props.dataItem)}>
                        <IconComponent
                          icon={FaEye}
                          style={{
                            color: "green",
                            fontSize: 18,
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </td>
            ),
          }}
        />
        <Column
          field="CreatedOn"
          title="Date"
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                {props.dataItem?.CreatedOn
                  ? moment(props.dataItem?.CreatedOn, "YYYY-MM-DD").format(
                      "DD/MM/YYYY",
                    )
                  : ""}
              </td>
            ),
          }}
        />
        <Column
          field="FirstName"
          title="Name"
          width={300}
          cells={{
            data: (props: any) => (
              <td className="fw-bold">
                {props.dataItem?.FirstName} {props.dataItem?.LastName}
              </td>
            ),
          }}
        />
        <Column
          field="MobileNo"
          title="Mobile No."
          width={200}
          cells={{ data: (props: any) => <td>{props.dataItem?.MobileNo}</td> }}
        />
        <Column
          field="EmailID"
          title="Email ID"
          width={300}
          cells={{ data: (props: any) => <td>{props.dataItem?.EmailID}</td> }}
        />
        <Column
          field="AirlineName"
          title="Airline"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.AirlineName}</td>,
          }}
        />
        <Column
          field="FromAirportName"
          title="From"
          width={140}
          cells={{
            data: (props: any) => <td>{props.dataItem?.FromAirportName}</td>,
          }}
        />
        <Column
          field="ToAirportName"
          title="To"
          width={140}
          cells={{
            data: (props: any) => <td>{props.dataItem?.ToAirportName}</td>,
          }}
        />
        <Column
          field="DepartureDate"
          title="Departure"
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                <p className="m-0">{props.dataItem?.DepartureDate}</p>
                <p className="m-0">{props.dataItem?.DepartureTime}</p>
              </td>
            ),
          }}
        />
        <Column
          field="ArrivalDate"
          title="Arrival"
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                <p className="m-0">{props.dataItem?.ArrivalDate}</p>
                <p className="m-0">{props.dataItem?.ArrivalTime}</p>
              </td>
            ),
          }}
        />
        <Column
          field="AdultsCost"
          title="Adult Cost"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.AdultsCost}</td>,
          }}
        />
        <Column
          field="ChildCost"
          title="Child Cost"
          width={120}
          cells={{
            data: (props: any) => <td>{props.dataItem?.ChildCost}</td>,
          }}
        />
        <Column
          field="CreatedByName"
          title="Created By"
          width={210}
          cells={{
            data: (props: any) => <td>{props.dataItem?.CreatedByName}</td>,
          }}
        />
        {/* <Column
          field="ID"
          title="Details"
          cells={{ data: ListingButtonCell }}
          width={"110px"}
          filterable={false}
          locked={true}
        /> */}
        {/* {(isEditAccess || isDeleteAccess || isAddAccess) && ( */}
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"170px"}
            filterable={false}
            locked={true}
          />
        {/* )} */}
      </KendoGrid>
    </>
  );
};

const DeleteFlightQuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const FlightQuotationID = useAppSelector(
    (state) => state.quotation.FlightQuotationID,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const FlightQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.FlightQuotationFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteFlightQuotation(ID));

      if (response.meta.requestStatus === "fulfilled") {
        dispatch(
          getAllFlightQuotations({
            ...FlightQuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearFlightQuotationID());
      } else {
        dispatch(
          getAllFlightQuotations({
            ...FlightQuotationFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
        dispatch(closeDialog());
        dispatch(clearFlightQuotationID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteFlightQuotation" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Flight Quotation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Flight Quotation?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(FlightQuotationID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const BookingConfirmationDialog: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();
//   const FlightQuotationID = useAppSelector(
//     (state) => state.quotation.FlightQuotationID
//   );
//   const loading = useAppSelector((state) => state.FITBooking.loading);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);
//   const gridRef = useRef<any>(null);

//   const handleConfirm = async (ID: number | null) => {
//     if (ID) {
//       const res = await dispatch(
//         generateFITBookingByQuotationID({ FlightQuotationID: ID })
//       );
//       if (res.meta.requestStatus === "fulfilled") {
//         dispatch(setCurrentPage(0));
//         dispatch(setPageLimit(50));
//         dispatch(closeDialog());
//         navigate("/fitbooking");
//       }
//     }
//   };

//   return (
//     <>
//       {dialogName === "bookingConfirmationDialog" && (
//         <AppDialog>
//           <>
//             {loading && <LoadingPanel gridRef={gridRef} />}
//             <Typography.h5>{"Booking Confirmation"}</Typography.h5>
//             <GridLayout>
//               <GridLayoutItem>
//                 <Typography.p>
//                   Are you sure you want to generate this Booking?
//                 </Typography.p>
//               </GridLayoutItem>
//               <GridLayoutItem
//                 style={{
//                   display: "flex",
//                   justifyContent: "end",
//                 }}
//               >
//                 <DialogCloseButton themeColor="primary" />
//                 <Button
//                   fillMode={"solid"}
//                   themeColor={"primary"}
//                   onClick={() => handleConfirm(FlightQuotationID)}
//                   type="button"
//                 >
//                   Confirm
//                 </Button>
//               </GridLayoutItem>
//             </GridLayout>
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

// const EmailConfirmationDialog: React.FC = () => {
//   // const dispatch = useAppDispatch();
//   const FlightQuotationID = useAppSelector(
//     (state) => state.quotation.FlightQuotationID
//   );
//   const loading = useAppSelector((state) => state.quotation.loading);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);
//   const gridRef = useRef<any>(null);

//   const handleConfirm = async (ID: number | null) => {
//     if (ID) {
//       // const res = await dispatch(sendQuotationByEmail(+ID));
//       // if (res.meta.requestStatus === "fulfilled") {
//       //   dispatch(closeDialog());
//       // }
//     }
//   };

//   return (
//     <>
//       {dialogName === "emailConfirmationDialog" && (
//         <AppDialog>
//           <>
//             {loading && <LoadingPanel gridRef={gridRef} />}
//             <Typography.h5>{"Email Confirmation"}</Typography.h5>
//             <GridLayout>
//               <GridLayoutItem>
//                 <Typography.p>
//                   Are you sure you want to send Email?
//                 </Typography.p>
//               </GridLayoutItem>
//               <GridLayoutItem
//                 style={{
//                   display: "flex",
//                   justifyContent: "end",
//                 }}
//               >
//                 <DialogCloseButton themeColor="primary" />
//                 <Button
//                   fillMode={"solid"}
//                   themeColor={"primary"}
//                   onClick={() => handleConfirm(FlightQuotationID)}
//                   type="button"
//                 >
//                   Confirm
//                 </Button>
//               </GridLayoutItem>
//             </GridLayout>
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

const ChildFlightQuotationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const FlightQuotationHistoryList = useAppSelector(
    (state) => state.quotation.FlightQuotationHistoryList,
  );
  const loading = useAppSelector((state) => state.quotation.loading);
  // const isAddAccess = checkAcessRights("/fitbooking", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const MyEditCommandCell = (data: any) => {
    const handleEdit = (item: any) => {
      navigate("/quotation/flight/edit", {
        state: {
          FlightQuotationID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteFlightQuotation"));
      dispatch(setFlightQuotationID(ID));
    };

    // const handleAddTourBooking = async (data: any) => {
    //   if (data?.ID) {
    //     dispatch(openDialog("bookingConfirmationDialog"));
    //     dispatch(setFlightQuotationID(data?.ID));
    //   }
    // };

    // const handleSendEmail = async (ID: number) => {
    //   if (ID) {
    //     dispatch(openDialog("emailConfirmationDialog"));
    //     dispatch(setFlightQuotationID(ID));
    //   }
    // };

    const handlePrint = async (FlightQuot_GUID: string) => {
      if (FlightQuot_GUID) {
        window.open(`/quotation/flight/view/${FlightQuot_GUID}`);
      }
    };

    const handleCopyMessage = async (ID: number, type = "email") => {
      try {
        if (ID) {
          const res = await dispatch(
            getFlightQuotationMessageForCopy({
              ID: ID,
              MessageType: type,
            }),
          );

          const htmlContent = res?.payload?.WhatsAppMessage || "";

          if (htmlContent) {
            let textToCopy = htmlContent;

            if (type === "whatsapp") {
              // Convert HTML to WhatsApp formatted text
              textToCopy = convertHtmlToWhatsAppFormat(htmlContent);
            } else if (type === "email") {
              // For email, copy as HTML with formatting
              await copyHtmlToClipboard(htmlContent);
              SuccessToast(
                `Message copied with formatting! You can now paste it in ${type}`,
              );
              return;
            }

            // Copy to clipboard
            await navigator.clipboard.writeText(textToCopy);

            SuccessToast(
              `Message copied to clipboard! You can now paste it in ${type}`,
            );
          } else {
            ErrorToast("No message found to copy.");
          }
        }
      } catch (error) {
        console.error("Failed to copy message:", error);
        alert("Failed to copy message. Please try again.");
      }
    };

    const handleCopyItemClick = (event: any, ID: number) => {
      const clickedItem = event?.item?.text;

      if (clickedItem === "Whatsapp") {
        handleCopyMessage(ID, "whatsapp");
      } else if (clickedItem === "Email") {
        handleCopyMessage(ID, "email");
      }
    };

    return (
      <td className="action-td">
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              // isEditBtnRef.current = true;
              handleEdit(data?.item);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {/* {isAddAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate FIT Booking"
            onClick={() => handleAddTourBooking(data?.item)}
            icon={FaBookMedical}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )} */}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(data?.item?.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(data?.item?.ID)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        /> */}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            themeColor="dark"
            onClick={() => handlePrint(data?.item?.FlightQuot_GUID)}
            icon={MdPrint}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <DropDownButton
            svgIcon={clipboardIcon}
            className="drop-down-btn"
            fillMode={"flat"}
            title="Copy Message"
            themeColor={"primary"}
            onItemClick={(event) => handleCopyItemClick(event, data?.item?.ID)}
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "center", vertical: "top" },
            }}
          >
            <DropDownButtonItem text="Whatsapp" />
            <DropDownButtonItem text="Email" />
          </DropDownButton>
        </Tooltip>
      </td>
    );
  };

  // const ListingButtonCell = (data: any) => {
  //   const handleBookings = (ID: number) => {
  //     navigate("/tourbooking", { state: { FlightQuotationID: ID } });
  //   };
  //   const handleFITBookings = (ID: number) => {
  //     navigate("/fitbooking", { state: { FlightQuotationID: ID } });
  //   };

  //   return (
  //     <td className={`action-td`}>
  //       {false && (
  //         <IconButton
  //           type="button"
  //           fillMode="flat"
  //           size="small"
  //           title="Tour Bookings"
  //           themeColor="tertiary"
  //           onClick={() => handleBookings(data?.item?.ID)}
  //           icon={BsBookmarkPlusFill}
  //           iconClassName="absolute-position"
  //           iconStyle={{ fontSize: "20px" }}
  //         />
  //       )}
  //       <IconButton
  //         type="button"
  //         fillMode="flat"
  //         size="small"
  //         title="FIT Bookings"
  //         themeColor="dark"
  //         onClick={() => handleFITBookings(data?.item?.ID)}
  //         icon={RiBookMarkedLine}
  //         iconClassName="absolute-position"
  //         iconStyle={{ fontSize: "20px" }}
  //       />
  //     </td>
  //   );
  // };

  return (
    <>
      {dialogName === "childFlightQuotationHistory" && (
        <AppDialog>
          <>
            <Typography.h5>{"Flight Quotation History"}</Typography.h5>
            <GridLayout style={{ position: "relative" }}>
              {loading && <LoadingPanel gridRef={gridRef} />}
              <GridLayoutItem
                style={{
                  maxHeight: "calc(100vh - 160px)",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                  borderBottom: "1px solid lightgray",
                }}
              >
                {FlightQuotationHistoryList &&
                FlightQuotationHistoryList?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr style={{ whiteSpace: "nowrap" }}>
                          <th style={{ background: "black", color: "white" }}>
                            Quotation No
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Airline
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            From
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            To
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Departure
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Arrival
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Adult Cost
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Child Cost
                          </th>
                          <th style={{ background: "black", color: "white" }}>
                            Created By
                          </th>
                          <th
                            style={{
                              background: "black",
                              color: "white",
                              minWidth: 130,
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {FlightQuotationHistoryList?.map(
                          (item: any, index: number) => (
                            <tr key={index}>
                              <td>
                                {isEditAccess ? (
                                  <div className="d-flex gap-2 align-items-center">
                                    <div
                                      className="hoverableName"
                                      onClick={() =>
                                        navigate("/quotation/flight/edit", {
                                          state: {
                                            FlightQuotationID: item?.ID,
                                            SectorID: item?.SectorID,
                                          },
                                        })
                                      }
                                    >
                                      {item?.FlightQuotationNo}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="normalName">
                                    {item?.FlightQuotationNo}
                                  </div>
                                )}
                              </td>
                              <td> {item?.AirlineName}</td>
                              <td> {item?.FromAirportName}</td>
                              <td> {item?.ToAirportName}</td>
                              <td>
                                <div>
                                  {item?.DepartureDate} {item?.DepartureTime}
                                </div>
                              </td>
                              <td>
                                <div>
                                  {item?.ArrivalDate} {item?.ArrivalTime}
                                </div>
                              </td>
                              <td>{item?.AdultsCost}</td>
                              <td>{item?.ChildCost}</td>
                              <td>{item?.CreatedByName}</td>
                              <td>
                                <MyEditCommandCell item={item} />
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <AlertBox style={{ marginBottom: 10 }} />
                )}
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 20,
                }}
              >
                <DialogCloseButton themeColor="error" />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default FlightQuotationGridComponent;
